import React from 'react'
import View from './View'
import { getMasterScheduleMissionExportData } from '../Campaigns/Page/MasterSchedule/util'
import { filterCompletedMissions } from '../StatsOverview/util'
import { normalizeGraphQLConnection } from '../../shared/graphql/utils'

const PivotTables = ({ campaignResults }) => {
  if (!campaignResults) return 'Loading...'

  const getCityPlan = cityPlanId =>
    campaignResults.cityPlans.nodes.find(({ id }) => id === cityPlanId)

  const campaignMissions = campaignResults.cityPlans.nodes.reduce(
    (acc, cityPlan) => [
      ...acc,
      ...normalizeGraphQLConnection(cityPlan.missions).map(mission => ({
        ...mission,
        cityPlanId: cityPlan.id,
        distributionCost: mission.distributionCost / 100,
      })),
    ],
    [],
  )

  const missions = campaignMissions
    .filter(filterCompletedMissions)
    .map(mission => {
      const cityPlan = getCityPlan(mission.cityPlanId)
      return getMasterScheduleMissionExportData({
        mission,
        campaign: campaignResults,
        campaignMissions,
        cityPlan: cityPlan,
        city: cityPlan.city,
      })
    })

  return <View missions={missions} />
}

export default PivotTables



// WEBPACK FOOTER //
// ./src/Containers/StatsPivotTables/Controller.js